/*jshint esversion: 6 */
/*jshint strict:false */

import Modal from './modal';
import TomSelect from "tom-select";

document.addEventListener('DOMContentLoaded', () => {
    const modalnode = document.querySelector('[data-behaviour="modalwin"]');
    const overlaynode = document.querySelector('[data-behaviour="overlay"]');
    const modal = new Modal(modalnode, overlaynode);
    window.modal = modal;

    const modalLinks = document.querySelectorAll('.show-modal');

    [...modalLinks].forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const href = e.currentTarget.href;
            const title = e.currentTarget.title;
            modal.load(href, title);
        });
    });

    const groupSwitches = document.querySelectorAll('[data-behaviour="group-switch"]');

    [...groupSwitches].forEach((link) => {
        link.addEventListener('click', (e) => {
            link.parentNode.parentNode.classList.toggle('booking-group--closed');

            if (document.querySelectorAll('.booking-group--closed').length) {
                document.querySelector(".reason").classList.add('reason--show');
            } else {
                document.querySelector(".reason").classList.remove('reason--show');
            }
        });
    });

    const selects = document.querySelectorAll('select.filter');
        [...selects].forEach(select => {
            const tomSelect = new TomSelect(select, {
                copyClassesToDropdown: false,
            });
            tomSelect.on('change', () => {
                const form = select.closest('form');
                form.submit();
            });
        });


});